export enum ApiRoutesEnum {
  SENSORS = 'sensors',
  SENSORS_BATCH_CREATE = 'sensors/batch',
  SENSORS_SEND_TO_SUBCONTRACTOR = 'sensors/production/send',
  SENSORS_INDICATE_STERILIZED = 'sensors/indicate-sterilized',
  SENSORS_ORDERS = 'sensors-orders',
  BOXES = 'boxes',
  BOXES_BATCH_CREATE = 'boxes/batch',
  BOXES_SEND_TO_SUBCONTRACTOR = 'production/send',
  PATIENTS = 'patients',
  CASE_EXPORT = 'patients/cases/export',
  ALGOS = 'algos',
  ALGOS_RESULTS = 'algos/results',
  FILES = 'files',
  SETTINGS = 'settings',
  HEALTH_CENTERS = 'health-centers',
  HEALTH_CENTERS_ORDERS = 'health-centers/:id/orders',
  HEALTH_CENTERS_SHORT_LIST_BY_NAME = 'short-list'
}
